module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees-sub-projects"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-3': _vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Medarbejdere\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.first_name ? ((props.row.first_name) + " " + (props.row.last_name)) : '-') + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'budget') ? _c('div', [_vm._v("\n                                -\n                            ")]) : (props.column.field == 'efficiency') ? _c('div', [_vm._v("\n                                -\n                            ")]) : (props.column.field == 'sub_projects_total_expenses') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.sub_projects_total_expenses)) + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 34418348)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', [_vm._v("\n                Vælg en medarbejder for at se en liste over dennes underopgaver med effektivitet\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('employee-sub-projects-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-292ea815"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/enterprise/components/employeesSubProjects.vue
// module id = 830
// module chunks = 0